import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import ProductSectionItem from './ProductSectionItem'

import { useDebounce } from 'util/hooks'
import { ProductSection } from 'panel/partner/product-config/redux/types'
import { createSectionItem } from 'panel/partner/product-config/redux/actions/section-item'
import { deleteSection, updateSection } from 'panel/partner/product-config/redux/actions/section'

const ProductSectionComponent: React.FC<{ section: ProductSection }> = ({ section }) => {
  const initialState = { isActive: true, preserveHigherPrice: false, name: '', min: 0, max: 0, order: 0 }
  const dispatch = useDispatch()
  const debounce = useDebounce()

  const [form, setForm] = useState(initialState)

  const { partnerId, id: pProdId } = useParams<{ [x: string]: string }>()

  function handleUpdate (): void {
    if (partnerId && pProdId) {
      debounce(() => {
        updateSection(partnerId, pProdId, section.id, form)(dispatch)
      }, 700)
    }
  }

  function handleIsActive (status: boolean): void {
    if (partnerId && pProdId) {
      updateSection(partnerId, pProdId, section.id, { isActive: status })(dispatch)
    }
  }

  function handlePreserveHigherPrice (status: boolean): void {
    if (partnerId && pProdId) {
      updateSection(partnerId, pProdId, section.id, { preserveHigherPrice: status })(dispatch)
    }
  }

  function handleRemove (): void {
    if (partnerId && pProdId && window.confirm('Tem certeza que deseja remover?')) {
      deleteSection(partnerId, pProdId, section.id)(dispatch)
    }
  }

  function handleAddItem (): void {
    if (partnerId && pProdId) {
      createSectionItem(partnerId, pProdId, section.id)(dispatch)
    }
  }

  useEffect(() => {
    if (section) {
      setForm({
        isActive: section.isActive,
        preserveHigherPrice: section.preserveHigherPrice,
        name: section.name,
        min: section.min,
        max: section.max,
        order: section.order
      })
    }
  }, [section])

  const gridTemplateColumns = '120px 100px 80px 300px 100px 100px'

  return (
    <div className="row panel-border">
      {/* Header */}
      <div className="row align-end">
        <div className="grow">
          <div className="row justify-start align-end" style={{ display: 'grid', gridTemplateColumns }}>
            <div className="form-control">
              <label>Maior preço?</label>
              <select
                value={section.preserveHigherPrice ? 1 : 0}
                onChange={(e): void => handlePreserveHigherPrice(parseInt(e.target.value) === 1)}
              >
                <option value={1}>Sim</option>
                <option value={0}>Não</option>
              </select>
            </div>

            <div className="form-control">
              <label>Ativo?</label>
              <select
                value={section.isActive ? 1 : 0}
                onChange={(e): void => handleIsActive(parseInt(e.target.value) === 1)}
              >
                <option value={1}>Sim</option>
                <option value={0}>Não</option>
              </select>
            </div>

            <div className="form-control">
              <label>Ordem</label>
              <input
                step={1}
                type="number"
                value={form.order}
                onChange={(e): void => setForm({ ...form, order: parseInt(e.target.value) })}
                onBlur={handleUpdate}
              />
            </div>

            <div className="form-control">
              <label>Nome</label>
              <input
                type="text"
                value={form.name}
                onChange={(e): void => setForm({ ...form, name: e.target.value })}
                onBlur={handleUpdate}
              />
            </div>
            <div className="form-control">
              <label>Mínimo</label>
              <input
                type="number"
                value={form.min}
                step={1}
                onChange={(e): void => setForm({ ...form, min: parseInt(e.target.value) })}
                onBlur={handleUpdate}
              />
            </div>
            <div className="form-control">
              <label>Máximo</label>
              <input
                type="number"
                value={form.max}
                step={1}
                onChange={(e): void => setForm({ ...form, max: parseInt(e.target.value) })}
                onBlur={handleUpdate}
              />
            </div>
          </div>
        </div>
        <span className="button remove" onClick={handleRemove}>
          <i className="fas fa-trash" /> Excluir Sessão
        </span>

        <span className="button primary margin-left-8" onClick={handleAddItem}>
          <i className="fas fa-plus"/> Adicionar Item
        </span>
      </div>

      {
        !!((section.items || []).length === 0 && (section.sections || []).length === 0) &&
        <div className="row empty margin-top-8">Nenhum item cadastrado</div>
      }
      {
        (section.items || []).map((item, i) => (
          <ProductSectionItem
            key={i}
            item={item}
            sectionId={section.id}
          />
        ))
      }
    </div>
  )
}

export default ProductSectionComponent
